import './ContentPriority.sass';

import React, { FC, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Header, ScrollView, SelectList } from '$uikit';
import { useTranslator } from '$hooks';
import { ContentPriorityType } from '$store/main/interface';
import { contentPrioritySelector } from '$store/main';
import { profileActions } from '$store/profile';
import { AuthRequired } from '$core';
import { authSelector } from '$store/auth';
import { rnbr } from '$utils';

export const ContentPriority: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const contentPriority = useSelector(contentPrioritySelector);
  const { isLogged } = useSelector(authSelector);

  const options = useMemo(
    () => [
      {
        label: t('edit_content_priority_button_other'),
        value: ContentPriorityType.OTHER,
      },
      {
        label: t('edit_content_priority_button_adult'),
        value: ContentPriorityType.ADULT,
      },
    ],
    [t],
  );

  const value =
    contentPriority === ContentPriorityType.NONE
      ? ContentPriorityType.OTHER
      : contentPriority;

  const handleChange = useCallback(
    ([value]: ContentPriorityType[]) => {
      dispatch(
        profileActions.changeContentPriority({
          contentPriority: value,
        }),
      );
    },
    [dispatch],
  );

  if (!isLogged) {
    return <AuthRequired />;
  }

  return (
    <>
      <Header showBackButton>{t('edit_content_priority_title')}</Header>
      <ScrollView>
        <div className="ContentPriority">
          <SelectList
            description={
              <>
                <b>{t('edit_content_priority_media_title')}</b>
                <div>{rnbr(t('edit_content_priority_media_caption'))}</div>
                <br />
                <b>{t('edit_content_priority_erotic_title')}</b>
                <div>{rnbr(t('edit_content_priority_erotic_caption'))}</div>
              </>
            }
            value={[value]}
            options={options}
            onChange={handleChange}
          />
        </div>
      </ScrollView>
    </>
  );
};
